import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.css'],
    standalone: false
})
export class StatusComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
    let mainElement: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement;
    let contentElement: HTMLElement = document.getElementsByClassName("content")[0] as HTMLElement;
  }
}